import { render, staticRenderFns } from "./TermsAndConditionsGb.vue?vue&type=template&id=3c90112e&"
import script from "./TermsAndConditionsGb.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsGb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports